import { connectHook } from '../../connect-hook.js';
import { NumberWidget } from './number.js';
import { useNumber } from './number-hook.js';

export default connectHook(NumberWidget, useNumber);
